import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Divider } from '@abyss/web/ui/Divider';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

export const CompareColumn = styled(Box, {
  '&.abyss-box-root': {
    backgroundColor: '$white',
  },
});
export const EditCompareAndPrintButton = styled(Flex, {
  flexWrap: 'nowrap',
  padding: '0px 12px',
  margin: '0px -16px',
  '@screen < $md': {
    padding: '0px',
  },
});
export const ProviderNameLinkStyle = (count, removeTruncatedDataCard?) => ({
  'abyss-text-root': {
    fontSize: '$md',
    fontWeight: '$bold',
    lineHeight: '18px',
    textAlign: 'left',
    color: ' $interactive1',
    cursor: 'pointer',
    maxWidth: count < 4 ? '100%' : count === 5 ? '190px' : '240px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...(removeTruncatedDataCard
      ? {
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          whiteSpace: 'normal',
          paddingTop: '10px',
        }
      : {
          display: 'inline-block',
          whiteSpace: 'nowrap',
        }),
    '@screen < $lg': {
      maxWidth: count < 4 ? '100%' : count === 5 ? '140px' : '170px',
      '@screen < $sm': {
        maxWidth: '150px',
        fontSize: '$sm',
      },
    },
  },
});

export const DividerStyle = styled(Divider, {
  backgroundColor: '$gray3 !important',
  height: '1px !important',
});

export const LayoutGroupStyled = styled(Layout.Group, {
  dynamic: ({ cssProps: { count, minHeightAuto, fullWidthDivs } }) => ({
    minHeight: minHeightAuto ? 'auto' : '30px',
    flexDirection: count > 3 ? 'column' : 'row',
    alignItems: count > 3 ? 'flex-start' : 'center',
    ...(fullWidthDivs && {
      '& > div': { width: '100%' },
    }),
    '@screen < $md': {
      '& .icon-name-container': {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
  }),
});

export const ProviderChangeButton = styled('div', {
  border: '1px solid #196ECF',
  borderRadius: '4px',
  width: '100%',
  marginTop: '8px',
  cursor: 'pointer',
  height: '36px',
  padding: '0 8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const IconAndText = styled(Flex, {
  alignItems: 'center',
  gap: '4px',
});

export const SectionHeadingStyled = styled(Text, {
  '&.abyss-text-root': {
    fontWeight: '700',
    fontSize: '20.25px',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'center',
  },
});

export const SectionBackgroundStyled = styled(Box, {
  '&.abyss-box-root': {
    width: '100%',
    padding: 8,
    textAlign: 'center',
    margin: '16px 0px',
  },
});

export const ProviderNameWithScore = styled(Flex, {
  alignItems: 'start',
  flexDirection: 'column',
  dynamic: ({ cssProps: { count, removeTruncatedDataCard } }) => ({
    gap: removeTruncatedDataCard && count > 3 ? '8px' : 'auto',
  }),
  '@screen < $md': {
    alignItems: 'center',
  },
});

export const ProviderNameWrapper = styled('div', {
  dynamic: ({ cssProps: { count, removeTruncatedDataCard } }) => ({
    minHeight: removeTruncatedDataCard && count > 3 ? '50px' : '40px',
  }),
});

export const CostIndicatorFlex = styled(Flex, {
  gap: '4px',
  flexWrap: 'nowrap',
  alignItems: 'flex-start',
  '& .abyss-text-root': {
    lineHeight: '24px',
  },
});

export const HoursOfOperationFlex = styled(Flex, {
  alignItems: 'center',
  marginBottom: '8px',
  justify: 'flex-start',
});

export const PremiumCareStyle = {
  fontSize: '16px',
  lineHeight: '20px',
};
